<template>
    <div align="center" class="row mt-4">
        <div class="col-sm">
            <img class="img-fluid" width="300" src="../assets/logo.png">
        </div>
    </div>
</template>

<script>
export default {
    name: 'Logo'
}
</script>

<style>

</style>